module.exports = __webpack_public_path__ + "media/images/client_logos/logo_loisirs_encheres_200-b90b2e042d19c9890f3c1b90a68e7061.png";